import { all } from "redux-saga/effects";
import { authSaga } from "./authSaga";
import { appConfigSaga } from "./common/appConfigSaga";

export default function* rootSaga(): any {
    yield all([
        authSaga(),
        appConfigSaga(),
    ])
}